import { gql } from '@apollo/client'

export const PDNFragments = {
    pdnMetadata: gql`
        fragment pdnMetadata on Metadata {
            created
            creatorId
            updaterId
            updated
            createdBy {
                role
                userType
                profileInfo {
                    firstName
                    lastName
                    title
                }
            }
        }
    `,
    pdnCommonFragment: gql`
        fragment pdnCommonFragment on ProductDetailNote {
            id
            listingId
            content
            reason
            seenByUserId
            productDetailNoteType
        }
    `,
}
